import { render, staticRenderFns } from "./VolumeOverviewChart.vue?vue&type=template&id=0b485260&scoped=true"
import script from "./VolumeOverviewChart.vue?vue&type=script&lang=js"
export * from "./VolumeOverviewChart.vue?vue&type=script&lang=js"
import style0 from "./VolumeOverviewChart.vue?vue&type=style&index=0&id=0b485260&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b485260",
  null
  
)

export default component.exports